import React from 'react';

function Navbar() {
  return (
    <nav>
      <div className="logo">PK</div>
      <ul className="nav-links">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
        <li><a href="https://games.phoenixkilgore.com" className="games-button">Games</a></li>
      </ul>
    </nav>
  );
}

export default Navbar; 